import './round_decimals';
import './is_nan';
import './text_to_number';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/math/index.js